// ============================================================
//  src/storage/user-drive-provider.js
//  Provider para Google Drive del usuario (scope drive.file)
// ============================================================

import { tienePermisosDrive, obtenerCarpetaDestino,
         subirArchivo, eliminarArchivoEnDrive }  from '../drive.js';
import { solicitarPermisosDrive }                from '../auth.js';

/**
 * Contrato:
 *   isAuthorized()          → boolean
 *   requestAuthorization()  → Promise<boolean>
 *   upload(file, context)   → Promise<{ fileId, fileUrl, providerMeta }>
 *   delete(fileId)          → Promise<boolean>
 *
 * context esperado en upload: { edicion, tipo }
 *   edicion — objeto de edición completo (necesario para obtenerCarpetaDestino)
 *   tipo    — 'log' | 'conf' | 'res' | 'cert' | 'reg'
 */
const userDriveProvider = {

    isAuthorized() {
        return tienePermisosDrive();
    },

    async requestAuthorization() {
        return solicitarPermisosDrive();
    },

    async upload(file, context) {
        const idCarpeta = await obtenerCarpetaDestino(context.edicion, context.tipo);
        const datos     = await subirArchivo(file, idCarpeta);

        return {
            fileId:      datos.id,
            fileUrl:     datos.webViewLink ?? null,
            providerMeta: null,
        };
    },

    async delete(fileId) {
        return eliminarArchivoEnDrive(fileId);
    },

};

export default userDriveProvider;
